import type { QuotedRate } from "@src/types/api";
import { resolveFtlOfferBaseUsd } from "@shared/utils/resolveFtlOfferBaseUsd";

export function selectTmsRowOffers(list: QuotedRate[]): QuotedRate[] {
  const kindOf = (o: QuotedRate) => o.quoteRowKind;
  const taggedTms = list.filter((o) => kindOf(o) === "tms");

  if (taggedTms.length > 0) {
    return taggedTms;
  }
  const heuristic = list.filter((o) => {
    if (kindOf(o) === "rating_engine") return false;
    const src = (
      o as {
        source?: string;
      }
    ).source;

    if (src === "Sonar") return false;
    if (typeof o.id === "string" && o.id.startsWith("sonar-")) return false;
    const hasTmsFields = typeof o.tmsCost === "number" || typeof o.tmsRate === "number";

    if (!hasTmsFields) return false;
    if (resolveFtlOfferBaseUsd(o) === 0) return false;
    const rateQuoteId =
      (
        o as {
          rateQuoteId?: string;
        }
      ).rateQuoteId?.trim() ?? "";
    const remitTo =
      typeof (
        o as {
          remitTo?: string;
        }
      ).remitTo === "string"
        ? (
            o as {
              remitTo?: string;
            }
          ).remitTo!.trim()
        : "";

    if (!rateQuoteId && !remitTo) return false;
    return true;
  });

  if (heuristic.length > 0) return heuristic;
  // Fall through to rating_engine rows (e.g. market-rate fallback injected when TMS has no offers)
  return list.filter((o) => kindOf(o) === "rating_engine");
}
export function stripTmsCustomerFieldsForFreshQuote(offers: QuotedRate[]): QuotedRate[] {
  if (!offers.length) return offers;
  const tmsIds = new Set(selectTmsRowOffers(offers).map((o) => o.id));

  return offers.map((o) => {
    if (!tmsIds.has(o.id)) return o;
    const next = { ...o };

    delete next.appliedCost;
    delete next.appliedMargin;
    delete next.appliedMarkupPercent;
    delete next.marginPct;
    delete next.totalBilledRate;
    return next;
  });
}
